/**
 * Canonical display titles for questionnaires.
 * Internal IDs (e.g. "telecom_v2") must never be shown to end users.
 * This map is the single source of truth for UI labels.
 */
const QUESTIONNAIRE_DISPLAY_TITLES: Record<string, string> = {
  hrv_self_v1: "Cybersecurity Risk Exposure Assessment",
  telecom_v2: "Telecom CSF 2.0 Assessment",
  telecom_self_v1: "Telecom Self-Assessment (NIST CSF – Light)",
  telecom_ai_v1: "Telecom AI Evidence Assessment",
  telecom_v1: "Telecom Full Assessment (NIST CSF)",
  ai_llm_self_v1: "AI & LLM Security Readiness Assessment",
  // MSP Starter Assessments
  cyber_posture_v1: "Cybersecurity Posture Assessment",
  data_privacy_law_v1: "Client Data Protection & Privacy (Law Firm-Specific)",
  iam_compromise_v1: "Identity & Access / Account Compromise Risk",
  ir_ransomware_v1: "Incident Response & Ransomware Readiness",
  vendor_risk_lite_v1: "Third-Party / Vendor Risk (Lightweight)",
  cyber_insurance_v1: "Cyber Insurance Readiness",
  // Pre-Investment Triage
  telecom_pre_investment_triage_v1: "Telecom Pre-Investment Cyber Risk Triage",
};

const DEFAULT_TITLE = "Cybersecurity Readiness Assessment";

/**
 * Returns a user-facing title for a questionnaire.
 * Checks, in order: the canonical map → meta.title → meta.label → meta.name → fallback.
 */
export function getQuestionnaireDisplayTitle(
  id: string,
  meta?: Record<string, unknown> | null,
): string {
  if (QUESTIONNAIRE_DISPLAY_TITLES[id]) return QUESTIONNAIRE_DISPLAY_TITLES[id];

  const metaTitle =
    (meta?.title as string) ??
    (meta?.label as string) ??
    (meta?.name as string);

  return metaTitle || DEFAULT_TITLE;
}
